<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" ref="searchForm">
          <el-form-item label="产品编码:" prop="employeeNo">
            <el-input v-model.trim="searchForm.filterData.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:" prop="employeeNo">
            <el-input v-model.trim="searchForm.filterData.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="风格:" prop="factory">
            <el-select v-model="searchForm.filterData.style" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in styles" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="空间: " prop="factory">
            <el-select v-model="searchForm.filterData.space" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in spaces" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="材质:" prop="factory">
            <el-select v-model="searchForm.filterData.material" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in materials" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用对象:" prop="factory">
            <el-select v-model="searchForm.filterData.useObject" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in useObjects" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类细分:" prop="factory">
            <el-select v-model="searchForm.filterData.category" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in categorys" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="功能:" prop="functionality">
            <el-input v-model.trim="searchForm.filterData.functionality" placeholder="请输入功能"></el-input>
          </el-form-item>
          <el-form-item label="系列:" prop="factory">
            <el-select v-model="searchForm.filterData.series" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in seriess" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属板块:" prop="factory">
            <el-select v-model="searchForm.filterData.plate" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in plates" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属类型:" prop="">
            <el-select v-model="searchForm.filterData.type">
              <el-option label="全部" value="" />
              <el-option v-for="item in types" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属店铺:" prop="">
            <el-select v-model="searchForm.filterData.shopName" filterable>
              <el-option label="全部" value="" />
              <el-option v-for="(item, index) in shopOptions" :key="index" :label="item.shopName" :value="item.shopName"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否含松木:" prop="">
            <el-select v-model="searchForm.filterData.containsPine">
              <el-option label="全部" value="" />
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适配床垫:" prop="adapterMattress">
            <el-input v-model.trim="searchForm.filterData.adapterMattress" placeholder="适配床垫"></el-input>
          </el-form-item>
          <el-form-item label="是否形象款:">
            <el-select v-model="searchForm.filterData.imageStyleFlag">
              <el-option label="全部" value=""></el-option>
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签:" prop="productLabel">
            <el-input v-model.trim="searchForm.filterData.productLabel" placeholder="标签"></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" class="green-btn" :visible.sync="dialogFormVisible" @click="showSubmit(false)">同步信息 </el-button>
        <el-button type="primary" size="small" class="green-btn" :visible.sync="dialogFormVisible" @click="importExcel()">导入 </el-button>
        <el-button type="primary" size="small" class="green-btn" :visible.sync="dialogFormVisible" @click="importImg()">导入图片 </el-button>
        <el-button type="primary" size="small" class="green-btn" @click="exportExcel">导出 </el-button>
      </template>
      <el-table
        border
        ref="tableRef"
        :height="maxTableHeight"
        v-if="tableReload"
        @select="serlectRow"
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          v-for="item in columnData"
          :key="item.columnName"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.columnName == 'photoUrls'">
              <el-button v-if="scope.row.imgUrlList && scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row, 'imgUrlList')"
                >查看</el-button
              >
              <el-button size="mini" @click="showUpload(scope.row, 2, 'imgUrlList')" type="text" v-if="scope.row.imgUrlList && scope.row.imgUrlList.length"
                >替换</el-button
              >
              <el-button size="mini" @click="showUpload(scope.row, 2, 'imgUrlList')" type="text" v-if="!scope.row.imgUrlList || !scope.row.imgUrlList.length"
                >上传</el-button
              >
            </template>
            <template v-else-if="item.columnName == 'backGroupImgUrlList'">
              <el-button
                v-if="scope.row.backGroupImgUrlList && scope.row.backGroupImgUrlList.length"
                size="mini"
                type="text"
                @click="viewImg(scope.row, 'backGroupImgUrlList')"
                >查看</el-button
              >
              <el-button
                size="mini"
                @click="showUpload(scope.row, 8, 'backGroupImgUrlList')"
                type="text"
                v-if="scope.row.backGroupImgUrlList && scope.row.backGroupImgUrlList.length"
                >替换</el-button
              >
              <el-button
                size="mini"
                @click="showUpload(scope.row, 8, 'backGroupImgUrlList')"
                type="text"
                v-if="!scope.row.backGroupImgUrlList || !scope.row.backGroupImgUrlList.length"
                >上传</el-button
              >
            </template>
            <template v-else-if="item.columnName == 'bottomImgUrlList'">
              <el-button
                v-if="scope.row.bottomImgUrlList && scope.row.bottomImgUrlList.length"
                size="mini"
                type="text"
                @click="viewImg(scope.row, 'bottomImgUrlList')"
                >查看</el-button
              >
              <el-button
                size="mini"
                @click="showUpload(scope.row, 9, 'bottomImgUrlList')"
                type="text"
                v-if="scope.row.bottomImgUrlList && scope.row.bottomImgUrlList.length"
                >替换</el-button
              >
              <el-button
                size="mini"
                @click="showUpload(scope.row, 9, 'bottomImgUrlList')"
                type="text"
                v-if="!scope.row.bottomImgUrlList || !scope.row.bottomImgUrlList.length"
                >上传</el-button
              >
            </template>
            <template v-else>
              {{ scope.row[item.columnName] }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="scope">
            <el-button type="text" @click="showSubmit(true, scope.row)">编辑</el-button>
            <el-button type="text" @click="showAdjustRecord(scope.row)">调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 编辑弹窗 -->
    <edit-dialog
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      :dialog-type="dialogType"
      :row="currentEditRow"
      :shop-options="shopOptions"
      @success="handleDialogSuccess"
    />
    <adjust-record-dialog
      v-if="adjustRecordVisible"
      :visible.sync="adjustRecordVisible"
      :row="currentAdjustRow"
    />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>

    <!-- 上传图片弹窗 -->
    <el-dialog title="上传视频及图片" :visible.sync="imgUploadFormVisible" :close-on-click-modal="false" width="60%">
      <imgUpload @save="saveImg" @cancel="imgUploadFormVisible = false" :imgListProp="imgListProp" :typeProp="upType" :disableVideo="true"></imgUpload>
    </el-dialog>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import imgShow from '@/views/components/imgShow';
import imgUpload from '@/views/components/imgUpload';
import editDialog from './components/editDialog.vue';
import adjustRecordDialog from './components/adjust-record-dialog.vue';
import { FILE_TYPE } from '@/utils/Global';
export default {
  name: 'baseattr',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow, imgUpload, editDialog, adjustRecordDialog },
  data() {
    return {
      // 图片弹窗
      imgFormVisible: false,
      imgList: [],
      reportName: 'productBaseAttrExport',
      columnData: [],
      // 图片上传弹窗
      imgUploadFormVisible: false,
      upType: 0,
      currentRow: [],
      imgListProp: [],

      editForm: {},
      tableReload: true,
      isSelector: true,
      searchCollapse: true,
      loading: true,
      startTime: null,
      endTime: null,
      form: {},
      styles: [],
      spaces: [],
      materials: [],
      useObjects: [],
      categorys: [],
      seriess: [],
      plates: [],
      types: [],
      shopOptions: [],
      // 弹窗相关
      dialogFormVisible: false,
      dialogType: false,
      currentEditRow: null,
      adjustRecordVisible: false,
      currentAdjustRow: null,
      searchForm: {
        pageNum: 1,
        pageSize: 30,
        filterData: {
          style: '',
          space: '',
          material: '',
          useObject: '',
          category: '',
          series: '',
          plate: '',
          type: '',
          shopName: '',
          imageStyleFlag: '',
          containsPine: '',
          productCode: null,
          productName: null,
          endDate: null,
        },
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      params: {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
      radio: null,
      endDatePicker: this.processDate(),
      startDatePicker: this.beginDate(),
    };
  },
  computed: {
    tableHeight() {
      if (this.searchCollapse) {
        return window.innerHeight - 243;
      } else {
        let formHeight = (this.$refs.searchWrapper && this.$refs.searchWrapper.offsetHeight) || 0;
        return window.innerHeight - formHeight - 243 + 49;
      }
    },
  },
  methods: {
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          time.setHours(8);
          if (self.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          time.setHours(8);
          if (self.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    serlectRow(i, v) {
      this.model = i;
    },
    showSubmit(type, row) {
      this.dialogType = type;
      this.currentEditRow = type ? row : null;
      this.dialogFormVisible = true;
    },
    showAdjustRecord(row) {
      this.currentAdjustRow = row;
      this.adjustRecordVisible = true;
    },
    handleDialogSuccess() {
      this.onSearch();
      this.onSearchForEnum();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    init() {
      this.searchForm.pageNum = this.tableData.pageNum;
      this.searchForm.pageSize = this.tableData.pageSize;
      this.loading = true;
      this.$q.product
        .listPage({
          data: {
            ...this.searchForm,
          },
        })
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        });
    },
    resetForm() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 30,
        filterData: {
          style: '',
          space: '',
          material: '',
          useObject: '',
          category: '',
          series: '',
          imageStyleFlag: '',
          plate: '',
          type: '',
          shopName: '',
          containsPine: '',
          productCode: null,
          productName: null,
          endDate: null,
        },
      };
      this.startTime = null;
      this.endTime = null;
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.init();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.init();
    },
    formatDate(date, fmt) {
      if (date == null) {
        return;
      }
      date = new Date(date);
      if (typeof fmt === 'undefined') {
        fmt = 'yyyy-MM-dd HH:mm:ss';
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
        }
      }
      return fmt;
    },
    //   时间格式化
    dateFormat(time) {
      if (null == time) {
        return;
      }
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
    onSearchForEnum() {
      this.$q.product.getPoductforEnum().then((res) => {
        if (res.code === 200) {
          this.styles = res.data.style;
          this.spaces = res.data.space;
          this.materials = res.data.material;
          this.useObjects = res.data.useObject;
          this.categorys = res.data.category;
          this.seriess = res.data.series;
          this.plates = res.data.plate;
          this.colors = res.data.color;
          this.shopOptions = res.data.belongsToStore;
          this.proudctFillerList = res.data.proudctFillerList; //填充物
          this.proudctFinishingProcessList = res.data.proudctFinishingProcessList; //饰面工艺
          this.productTypeList = res.data.productTypeList; //产品类型
          this.proudctTableMaterialList = res.data.proudctTableMaterialList; //台面材质
          this.proudctFootTypeList = res.data.proudctFootTypeList; //脚类型
          this.proudctHandleTypeList = res.data.proudctHandleTypeList; //拉手类型
        }
      });
    },
    // 导入-excel
    importExcel() {
      this.openSubPage({
        //核心语句
        //复制
        path: '/product/baseattrImport',
        // name: 'importexcelproduct',   //跳转的路径
        query: {
          fileName: '产品属性导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'productBaseAttrImport',
        },
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: this.searchForm.filterData,
          reportName: this.reportName,
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnData));
      params.columnDTOs = tmp
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: 'string',
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != '图片');
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally((_) => {
          loading.close();
        });
    },
    // 图片导入
    importImg() {
      // 核心语句
      this.openSubPage({
        path: '/ImportImgProduct',
        name: 'ImportImgProduct', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          fileType: FILE_TYPE.产品图片,
        },
      });
    },
    // 查看图片
    viewImg(row, key) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row[key] ? row[key] : [];
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
    // 显示图片上传
    showUpload(row, type, key) {
      this.currentRow = row;
      this.imgListProp = row[key] ? [...row[key]] : [];
      this.imgUploadFormVisible = true;
      this.upType = type;
    },

    // 保存已上传的图片
    saveImg(data) {
      this.imgUploadFormVisible = false;
      for (let s of data) {
        s.relationId = this.currentRow.proBaseAttrId;
      }
      this.editData = { imgList: data, code: this.currentRow.productCode, type: this.upType };
      this.editDeliveryCycle();
    },

    editDeliveryCycle() {
      this.$q.product
        .baseEdit({ data: this.editData })
        .then((res) => {
          this.editData = {};
          this.$message.success('操作成功');
          this.onSearch();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    delImg(code) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$q.product
          .baseDelete({ data: JSON.stringify({ productCode: code }) })
          .then((res) => {
            this.$message.success('删除成功');
            this.onSearch();
          })
          .catch((error) => {
            this.$message.error(error.message);
          });
      });
    },
    onCollapse() {
      this.searchCollapse = !this.searchCollapse;
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
    },
    // 所属类型
    get_types() {
      this.$q.product.getType().then((res) => {
        this.types = res.data;
      });
    },
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.onSearch();
      });
    },
  },

  mounted() {
    this.columns();
    this.onSearchForEnum();
    this.get_types();
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-dialog {
  margin: 50px auto !important
}
.search-wrapper
  margin 10px
  padding 10px
  padding-bottom 0px
  background-color #ffffff

  >>> .el-form-item
    margin-bottom 10px

  >>> .el-divider
    margin 10px 0

.list-wrapper
  margin 10px
  background-color #ffffff

.table-wrap
  padding 10px

.wrap_tooltip {
  display: inline-block;
  max-width: 200px; // 最大的宽度，必写属性
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  height: 28px
}

 >>> .requestParam .el-date-editor, >>> .requestParam .el-select, >>> .requestParam .el-input {
  width: 170px !important;
}

 >>> .requestParam .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .requestParam  .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}

>>> .el-row {
  display: flex; //设置布局
  flex-wrap: wrap; //进行换行操作
  }
</style>
